import { State, Action, Selector } from '@ngxs/store';
import { mergeWith } from 'lodash';
import { EmploiModele } from './modeles/emploi.modele';
import { PreferenceModel } from '../core/modeles/personneModele';
import { CoordonneesModele } from './modeles/coordonnees.modele';
import { Injectable } from '@angular/core';

const defaultState = {
  preferences: null,
  emploi: null,
  coordonnees: null
};

export interface PreferencesStateModel {
  preferences: PreferenceModel;
  emploi: EmploiModele;
  coordonnees: CoordonneesModele;
}

export class UpdatePreferences {
  static type = '[Preference] UpdatePreferences';
  constructor(public preferences: PreferenceModel) {}
}

export class UpdateEmploi {
  static type = '[Preference] UpdateEmploi';
  constructor(public emploi: EmploiModele) {}
}

export class UpdateCoordonnees {
  static type = '[Preference] UpdateCoordonnees';
  constructor(public coordonnees: CoordonneesModele) {}
}

@Injectable()
@State<PreferencesStateModel>({
  name: 'preference',
  defaults: defaultState
})
export class PreferencesState {
  @Selector()
  static getPreferences(state: PreferencesStateModel) {
    return state.preferences;
  }

  @Selector()
  static getEmploi(state: PreferencesStateModel) {
    return state.emploi;
  }

  @Action(UpdatePreferences)
  updatePreferences({ patchState, getState }, { preferences }: UpdatePreferences) {
    const state = getState();

    const updatedPreferences = mergeWith(state.preferences, preferences);

    patchState({
      preferences: updatedPreferences
    });
  }

  @Action(UpdateEmploi)
  updateEmploi({ patchState, getState }, { emploi }: UpdateEmploi) {
    const state = getState();

    const updatedEmploi = mergeWith(state.emploi, emploi);

    patchState({
      emploi: updatedEmploi
    });
  }

  @Action(UpdateCoordonnees)
  updateCoordonnees({ patchState, getState }, { coordonnees }: UpdateCoordonnees) {
    const state = getState();

    const updatedCoordonnees = mergeWith(state.coordonnees, coordonnees);

    patchState({
      coordonnees: updatedCoordonnees
    });
  }
}
